//This is the original adapter of @tanstack/react-table because we were getting error during instalion
//we paste the code directly here.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
export * from "@tanstack/table-core";
import { createTableInstance, createTableFactory } from "@tanstack/table-core";
function isExoticComponent(component) {
    return (typeof component === "object" &&
        typeof component.$$typeof === "symbol" &&
        ["react.memo", "react.forward_ref"].includes(component.$$typeof.description));
}
function isClassComponent(component) {
    return (typeof component === "function" &&
        (function () {
            var proto = Object.getPrototypeOf(component);
            return proto.prototype && proto.prototype.isReactComponent;
        })());
}
function isReactComponent(component) {
    return (isClassComponent(component) || typeof component === "function" || isExoticComponent(component));
}
export var render = function (Comp, props) {
    return !Comp ? null : isReactComponent(Comp) ? React.createElement(Comp, __assign({}, props)) : Comp;
};
export var createTable = createTableFactory({ render: render });
export function useTableInstance(table, options) {
    var resolvedOptions = __assign(__assign(__assign({}, table.options), { state: {}, onStateChange: function () { }, // noop
        render: render, renderFallbackValue: null }), options);
    // Create a new table instance and store it in state
    var instanceRef = React.useState(function () { return ({
        current: createTableInstance(resolvedOptions),
    }); })[0];
    // By default, manage table state here using the instance's initial state
    var _a = React.useState(function () { return instanceRef.current.initialState; }), state = _a[0], setState = _a[1];
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    instanceRef.current.setOptions(function (prev) { return (__assign(__assign(__assign({}, prev), options), { state: __assign(__assign({}, state), options.state), 
        // Similarly, we'll maintain both our internal state and any user-provided
        // state.
        onStateChange: function (updater) {
            var _a;
            setState(updater);
            (_a = options.onStateChange) === null || _a === void 0 ? void 0 : _a.call(options, updater);
        } })); });
    return instanceRef.current;
}
